import { Filter, RotateCcw, Search, ListOrdered, Download, Settings, Image } from "lucide-react";
import { useState, useEffect } from "react";
import { StatusFilterPhotoMeter, PhotoMeterItem, RekairKoreksi, StatusFilterRekairKoreksi } from "../../../../model/Hublang";
import { fetchGetDataRekairPeriode, fetchGetPhotoMeterAll, fetchGetPhotoMeterTagihanAll, fetchPathDataRekairKoreksi } from "../../../../controller/dashboard/Cekmeter";
import { CSV } from "../../../../util/ExportFile";

export const KoreksiMeter = () => {

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState<StatusFilterRekairKoreksi>({
        nama: 'all',
        nsb: 'all',
        alamat: 'all',
        klasf: 'all',
        pelanggan: 'all',
        pakai: 'all',
        met_l: 'all',
        met_k: 'all',
        adm : 'all',
        harga : 'all',
        denda: 'all',
    });

    
    const [statusLength, setStatusLength] = useState('10');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [photoMeterData, setPhotoMeterData] = useState<RekairKoreksi[]>([]);
    const [selectedPhotoMeter, setSelectedPhotoMeter] = useState<RekairKoreksi | null>(null);
    const [periodeGet, setPeriodeGet] = useState<string>('null');
    const [bulanGet, setBulanGet] = useState<string>('null');
    const [tahunGet, setTahunGet] = useState<string>('null');
    const [sortConfig, setSortConfig] = useState<{ key: keyof RekairKoreksi | null; direction: 'asc' | 'desc' }>({
        key: null,
        direction: 'asc',
    });
    // Tambahkan di deretan useState lainnya
    const [showNegativeOnly, setShowNegativeOnly] = useState<string>('all'); // 'all' atau 'minus'
    const [minPakaiFilter, setMinPakaiFilter] = useState<string>(''); // Nilai input angka
    const [showZeroHarga, setShowZeroHarga] = useState<string>('all'); // 'all' atau 'zero'
  
    const filteredPhotoMeters = photoMeterData.filter(plg => {
      const matchesSearch =plg.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
        plg.nama.includes(searchTerm) ||
        plg.nsb.includes(searchTerm) ||
        plg.alamat.includes(searchTerm) ||
        plg.klasf.includes(searchTerm) ||
        plg.pelanggan.includes(searchTerm)
  
      const matchesStatus = 
        (statusFilter.nama === 'all' || plg.nama === statusFilter.nama) &&
        (statusFilter.nsb === 'all' || plg.nsb === statusFilter.nsb) &&
        (statusFilter.alamat === 'all' || plg.alamat === statusFilter.alamat) &&
        (statusFilter.pakai === 'all' || plg.pakai === statusFilter.pakai) &&
        (statusFilter.klasf === 'all' || plg.klasf === statusFilter.klasf) &&
        (statusFilter.pelanggan === 'all' || plg.pelanggan === statusFilter.pelanggan)

      const hasRValues = 
        (plg.R1 !== '0' && plg.R1 !== '-' && plg.R1 !== '') || 
        (plg.R2 !== '0' && plg.R2 !== '-' && plg.R2 !== '') || 
        (plg.R3 !== '0' && plg.R3 !== '-' && plg.R3 !== '');

      const nilaiHarga = parseFloat(plg.harga) || 0;

      // Logika Filter Harga Baru
      const matchesPriceFilter = 
        showZeroHarga === 'all' || 
        (showZeroHarga === 'zero' && nilaiHarga === 0) ||
        (showZeroHarga === 'has-r-price' && nilaiHarga >= 0 && hasRValues);

      const nilaiPakai = parseFloat(plg.pakai) || 0;
  
      const matchesNegative = showNegativeOnly === 'all' || (showNegativeOnly === 'minus' && nilaiPakai < 0);
      
      const matchesMinPakai = minPakaiFilter === '' || nilaiPakai > parseFloat(minPakaiFilter);

      const matchesZeroHarga = showZeroHarga === 'all' || (showZeroHarga === 'zero' && (parseFloat(plg.harga) === 0 || plg.harga === '0'));
  
      return matchesSearch && matchesStatus && matchesNegative && matchesMinPakai && matchesPriceFilter && matchesZeroHarga;
    }).sort((a, b) => {
        // Logika Sorting Baru
        if (sortConfig.key !== null) {
            const aValue = a[sortConfig.key];
            const bValue = b[sortConfig.key];

            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
        }
        return 0;
    });
  
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = filteredPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];
  
    const initDataPhotoMeter = async (periode : string) => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetDataRekairPeriode(periode); // Panggil API
            console.log(res); // Log response untuk debugging
            if (res.status === 200 && Array.isArray(res.data)) {
  
              const today = new Date();
              today.setHours(0, 0, 0, 0);
  
                const processedData = res.data.map((item: any) => ({
                    no: 0,
                    nama: item.NAMA || "Tidak ada data",
                    nsb: item.NOSAMW || "Tidak ada data",
                    alamat: item.ALAMAT || "Tidak Ada Alamat",
                    klasf: item.KLASF || "Tidak ada data",
                    pelanggan: item.stat_smb === "30" ? "Aktif" : item.stat_smb === "40" ? "Cabut Meter" : item.stat_smb === "20" ? "Segel" : item.stat_smb,
                    pakai: item.PAKAI || "Tidak ada PAKAI",
                    met_l: item.MET_L || "Tidak ada MET_L",
                    met_k: item.MET_K || "Tidak ada MET_K",
                    adm : item.adm || "0",
                    R1 : item.R1 || "0",
                    R2 : item.R2 || "0",
                    R3 : item.R3 || "0",
                    harga : item.R4 || "0",
                    T1 : item.T1 || "0",
                    T2 : item.T2 || "0",
                    T3 : item.T3 || "0",
                    T4 : item.T4 || "0",
                    B1 : item.B1 || "0",
                    B2 : item.B2 || "0",
                    B3 : item.B3 || "0",
                    B4 : item.B4 || "0",
                    denda : item.denda || "0",
                    noblth : item.NOBLTH || "-",

                }));

                const sortedData = processedData;
                setPhotoMeterData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPhotoMeterData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPhotoMeterData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleShowDetail = (pm : RekairKoreksi) => {
      console.log(pm);
        setSelectedPhotoMeter(pm);
        setShowDetailModal(true);
    }

    const handleRefresh = () => {
      initDataPhotoMeter(periodeGet);
    }

    const requestSort = (key: keyof RekairKoreksi) => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };
    

    useEffect(() => {
      // initDataPhotoMeter();
      // setItemsPerPage(Number(statusLength === 'all' ? photoMeterData.length : statusLength))
      if(bulanGet !== 'null' && tahunGet !== 'null') {
        setPeriodeGet(`${tahunGet}${bulanGet}`);
        initDataPhotoMeter(`${tahunGet}${bulanGet}`);
      }
    }, [bulanGet, tahunGet]);

    return (
      <>
        {/* Controls 2*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              {/* Filter */}
              <button 
                onClick={() => initDataPhotoMeter(periodeGet)}
                disabled={loading}
                className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                {loading ? "Memuat..." : "Muat Ulang"}
              </button>

              <ExportCSV  data={selectedPhotoMeter}/>

              <div className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                {periodeGet !== 'null' ?  `PERIODE : ${periodeGet}` : ''}
              </div>

              {/* <div className="relative">
                <select
                  value={showNegativeOnly}
                  onChange={(e) => setShowNegativeOnly(e.target.value)}
                  className="pl-4 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-40 bg-white"
                >
                  <option value="all">Semua Pakai</option>
                  <option value="minus">Hanya Minus</option>
                </select>
              </div> */}
            </div>

            <div className="flex space-x-3">
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Cari nama atau NIK..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                />
              </div>

              {/* Length*/}
              <div className="relative">
                <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <select
                  value={statusLength}
                  onChange={(e) => {setStatusLength(e.target.value); setItemsPerPage(Number(e.target.value === 'all' ? photoMeterData.length : e.target.value))}}
                  className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option> 
                  <option value="500">500</option>
                  <option value="all">Tampil Semua</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                {/* Input Minimal Pakai */}
              <div className="relative">
                <input
                  type="number"
                  placeholder="Pakai > dari..."
                  value={minPakaiFilter}
                  onChange={(e) => setMinPakaiFilter(e.target.value)}
                  className="pl-4 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-40"
                />
              </div>

              <div className="relative">
                <select
                  value={showZeroHarga}
                  onChange={(e) => setShowZeroHarga(e.target.value)}
                  className="pl-4 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-40 bg-white text-sm"
                >
                  <option value="all">Semua Harga</option>
                  <option value="zero">Harga Rp. 0</option>
                  <option value="has-r-price">Harga `{'>'}` 0 & Ada R1/R2/R3</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              {/* <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NAMA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NSB
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    ALAMAT
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PELANGGAN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    KLASF
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    MET LALU
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    MET KINI
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PAKAI
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  </th>
                </tr>
              </thead> */}
                <thead className="bg-gray-50">
                  <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          NO
                      </th>
                      {[
                          { label: 'NAMA', key: 'nama' },
                          { label: 'NSB', key: 'nsb' },
                          { label: 'ALAMAT', key: 'alamat' },
                          { label: 'PELANGGAN', key: 'pelanggan' },
                          { label: 'KLASF', key: 'klasf' },
                          { label: 'MET LALU', key: 'met_l' },
                          { label: 'MET KINI', key: 'met_k' },
                          { label: 'PAKAI', key: 'pakai' },
                      ].map((header) => (
                          <th 
                              key={header.key}
                              onClick={() => requestSort(header.key as keyof RekairKoreksi)}
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                          >
                              <div className="flex items-center space-x-1">
                                  <span>{header.label}</span>
                                  {sortConfig.key === header.key && (
                                      <span>{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>
                                  )}
                              </div>
                          </th>
                      ))}
                      <th className="px-6 py-3"></th>
                  </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                      <RenderTablePhotoMeterPelanggan filteredData={currentPhotoMeters} onOpenDetail={handleShowDetail} periodeGet={periodeGet} bulanGet={bulanGet} tahunGet={tahunGet} setBulanGet={setBulanGet} setTahunGet={setTahunGet} />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
          <span className="font-medium">{statusLength === "all" ? photoMeterData.length : statusLength}</span> dari{' '}
          <span className="font-medium">{photoMeterData.length}</span> karyawan
          <span className="font-medium">( Dari Sortir {filteredPhotoMeters.length} )</span>
        </div>
        <div className="flex space-x-2">
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          First
          </button>
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          Previous
          </button>
          
          {pageNumbers
          .slice(
            Math.max(0, currentPage - 3), 
            Math.min(currentPage + 2, totalPages)
          )
          .map((page) =>( 
            <button 
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
            {page}
            </button>
          ))}
          
          <button 
              disabled={currentPage === Math.ceil(filteredPhotoMeters.length / itemsPerPage)}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Next
          </button>
          <button 
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Last
          </button>
        </div>
        </div>

        {showDetailModal && <DetailPreviewModal pelangganPMDetail={selectedPhotoMeter} stateShowModal={setShowDetailModal} onRefresh={handleRefresh} />}
      </>
    )
}

const openImage = (photo : string) => {
    window.open(photo, '_blank');
}

export const ExportCSV = (data : any) => {
    return (
        <button 
            onClick={async () => {
                try {
                   const response = await CSV(data, "Export_PhotoMeter");
                } catch (error) {
                    console.error("Error exporting CSV:", error);
                }
            }}
            className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
            <Download className="w-4 h-4 mr-2" />
            { "Export" }
        </button>
    )
}

export const RenderTablePhotoMeterPelanggan = ({ filteredData, onOpenDetail, periodeGet, bulanGet, tahunGet, setBulanGet, setTahunGet }: { 
    filteredData: RekairKoreksi[] | null; 
    onOpenDetail : (employee: RekairKoreksi) => void;
    periodeGet: string;
    bulanGet: string;
    tahunGet: string;
    setBulanGet: (value: string) => void;
    setTahunGet: (value: string) => void;
}) => (
  <>
    {/* {periodeGet} */}
    {
      periodeGet != 'null' && filteredData && filteredData.length > 0 ? (
        filteredData.map((plg, idx) => {

          const hasRValues = 
            (plg.R1 !== '0' && plg.R1 !== '') || 
            (plg.R2 !== '0' && plg.R2 !== '') || 
            (plg.R3 !== '0' && plg.R3 !== '');

          
          const rowStyles = hasRValues 
            ? "bg-blue-100 hover:bg-blue-200 border-l-4 border-blue-600" 
            : "bg-white hover:bg-slate-50 border-l-4 border-transparent";

          return (
            <tr key={idx} className={`transition-all duration-200 ${rowStyles}}`}>
              <td className="px-6 py-4 whitespace-nowrap relative font-medium text-gray-700">
                {idx + 1}
                {hasRValues && (
                  <span className="absolute top-2 left-1 flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
                  </span>
                )}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.nama}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                {plg.nsb}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.alamat}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.pelanggan}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.klasf}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.met_l}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.met_k}
              </td>
              {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.pakai}
                {hasRValues && (
                  <span className="text-[10px] text-blue-600 font-semibold uppercase italic">
                    + Ada R1/R2/R3
                  </span>
                )}
              </td> */}

              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex flex-col">
                  <span className={`w-fit px-2 py-0.5 rounded text-xs font-bold ${parseFloat(plg.harga) === 0 ? 'bg-red-500 text-white' : (hasRValues ? 'bg-emerald-100 text-emerald-700' : 'text-gray-900')}`}>
                    {plg.pakai}
                  </span>
                  {hasRValues && (
                    <span className="text-[10px] text-blue-700 font-extrabold mt-1 tracking-tighter italic">
                      REK-AIR KHUSUS (R1/R2/R3)
                    </span>
                  )}
                </div>
            </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                <button onClick={() => { onOpenDetail(plg) }} className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                ><Settings /></button>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
            <td colSpan={18} className="text-center py-4 text-gray-500">
            <div className="py-8">
              {periodeGet != 'null' && (
                <p className="mb-6 text-gray-700 font-medium">Tidak ada rekening air, Silahkan coba lagi</p>
              )}
              <p className="mb-6 text-gray-700 font-medium">Masukkan Periode untuk melihat Rekair</p>
              {/* { bulanGet !== 'null' && tahunGet !== 'null' ? "ada" : "tidak ada" } */}
              <div className="flex flex-col md:flex-row gap-4 justify-center max-w-md mx-auto">
              <select 
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={bulanGet}
                onChange={(e) => setBulanGet(e.target.value)}
              >
                <option value="null">Pilih Bulan</option>
                {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                  <option key={month} value={month.toString().padStart(2, '0')}>{month.toString().padStart(2, '0')}</option>
                ))}
              </select>
              <select 
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={tahunGet}
                onChange={(e) => setTahunGet(e.target.value)}
              >
                <option value="null">Pilih Tahun</option>
                {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                  <option key={year} value={year.toString()}>{year}</option>
                ))}
              </select>
              </div>
            </div>
            </td>
        </tr>
      )
    }
  </>
);

export const DetailPreviewModal = ({ pelangganPMDetail, stateShowModal, onRefresh }: { 
    pelangganPMDetail: RekairKoreksi | null; 
    stateShowModal: (show: boolean) => void | false;
    onRefresh: () => void;
}) => {
    interface FormState {
      mlalu: string;
      mkini: string;
      pakai: string;
      hair: string;
      adm: string;
      denda: string;
      R1: string;
      R2: string;
      R3: string;
      T1: string;
      T2: string;
      T3: string;
      T4: string;
      B1: string;
      B2: string;
      B3: string;
      B4: string;
    }

    const [moreEdit, setMoreEdit] = useState(false);

    const [formData, setFormData] = useState<FormState>({
      mlalu: pelangganPMDetail?.met_l || '-',
      mkini: pelangganPMDetail?.met_k || '-',
      pakai: pelangganPMDetail?.pakai || '-',
      hair: pelangganPMDetail?.harga || '-',
      adm: pelangganPMDetail?.adm || '-',
      denda: pelangganPMDetail?.denda || '-',
      R1: pelangganPMDetail?.R1 || '-',
      R2: pelangganPMDetail?.R2 || '-',
      R3: pelangganPMDetail?.R3 || '-',
      T1: pelangganPMDetail?.T1 || '-',
      T2: pelangganPMDetail?.T2 || '-',
      T3: pelangganPMDetail?.T3 || '-',
      T4: pelangganPMDetail?.T4 || '-',
      B1: pelangganPMDetail?.B1 || '-',
      B2: pelangganPMDetail?.B2 || '-',
      B3: pelangganPMDetail?.B3 || '-',
      B4: pelangganPMDetail?.B4 || '-'
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmitDetail = async ( dataFirst :  RekairKoreksi, data : any) => {
      console.log({ nsb: dataFirst.nsb, noblth: dataFirst.noblth, ...data });
        try {
            // Panggil API untuk submit koreksi meter
            const response = await fetchPathDataRekairKoreksi({ nsb: dataFirst.nsb, noblth: dataFirst.noblth, ...data });
            if (response.status === 200) {
                alert("Koreksi meter berhasil disubmit!");
                stateShowModal(false);
                onRefresh();
            } else {
                alert("Gagal submit koreksi meter. Silakan coba lagi.");
            }
        } catch (error) {
            console.error("Error submitting koreksi meter:", error);
            alert("Gagal submit koreksi meter. Silakan coba lagi.");
        }
    }

    return(
        <>
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 p-6 overflow-hidden">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h3 className="text-xl font-semibold text-gray-800">Detail Pelanggan : {pelangganPMDetail?.nama} </h3>
                        <div className="text-xl font-semibold text-gray-500">Pelanggan : {pelangganPMDetail?.pelanggan}</div>
                        <div className="text-xl font-semibold text-gray-500">Klasf : {pelangganPMDetail?.klasf}</div>
                        <div className="text-xl font-semibold text-gray-500">No. Sambung : {pelangganPMDetail?.nsb}</div>
                    </div>
                    <button
                        onClick={() => stateShowModal(false)}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                        ✕
                    </button>
                </div>

                <div className="space-y-4 overflow-y-auto max-h-[70vh]">
                    {/* Form Grid */}
                    <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                      {[
                        { label: 'MLALU', name: 'mlalu' },
                        { label: 'MKINI', name: 'mkini' },
                        { label: 'PAKAI', name: 'pakai' },
                        { label: 'HAIR', name: 'hair' },
                        { label: 'ADM', name: 'adm' },
                        { label: 'DENDA', name: 'denda', placeholder: 'DENDA' }
                      ].map((field) => (
                        <div key={field.name} className="flex flex-col">
                          <label className="text-xs font-bold text-gray-500 mb-1 tracking-wider">
                            {field.label}
                          </label>
                          <input
                            type="text"
                            name={field.name}
                            value={(formData as any)[field.name]}
                            placeholder={field.placeholder}
                            onChange={handleChange}
                            className="border border-gray-300 rounded px-3 py-2 text-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500 placeholder-gray-400"
                          />
                        </div>
                      ))}
                    </div>
                    <div className="border-t border-gray-200 my-6"></div>
                    <button
                      onClick={() => setMoreEdit(!moreEdit)}
                      className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      {moreEdit ? "Sembunyikan" : "Tampilkan"} Detail Lainnya
                    </button>
                    {
                      moreEdit ? 
                        <>
                          <div className="space-y-4 overflow-y-auto max-h-[70vh]">
                            <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                              {[
                                { label: 'R1', name: 'R1' },
                                { label: 'R2', name: 'R2' },
                                { label: 'R3', name: 'R3' },
                                { label: 'T1', name: 'T1' },
                                { label: 'T2', name: 'T2' },
                                { label: 'T3', name: 'T3' },
                                { label: 'T4', name: 'T4' },
                                { label: 'B1', name: 'B1' },
                                { label: 'B2', name: 'B2' },
                                { label: 'B3', name: 'B3' },
                                { label: 'B4', name: 'B4' },
                              ].map((field) => (
                                <div key={field.name} className="flex flex-col">
                                  <label className="text-xs font-bold text-gray-500 mb-1 tracking-wider">
                                    {field.label}
                                  </label>
                                  <input
                                    type="text"
                                    name={field.name}
                                    value={(formData as any)[field.name]}
                                    onChange={handleChange}
                                    className="border border-gray-300 rounded px-3 py-2 text-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500 placeholder-gray-400"
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                       :
                        ''
                    }
                    
                </div>
                <div className="flex justify-end gap-3 mt-8">
                  <button 
                    onClick = {() => stateShowModal(false)}
                    className="px-8 py-2 bg-gray-200 text-gray-700 rounded-md font-medium hover:bg-gray-300 transition-colors">
                    Cancel
                  </button>
                  <button 
                    onClick={() => pelangganPMDetail && handleSubmitDetail(pelangganPMDetail, formData)}
                    className="px-8 py-2 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition-colors">
                    Submit
                  </button>
                </div>
            </div>
        </div>
        </>
    );
}
